import { useContent } from "src/shared/components/content";
import { PE_KEYS } from "src/shared/constants/PageEventKeys";
import { useScrollPastTracking } from "src/shared/hooks/useScrollTracking";
import { useContentLayoutContext } from "src/website-apps/shared/context/ContentLayoutContext";
import { FanProtectImageWithLink } from "./FanProtectImage";
import { FanProtectLink } from "./FanProtectLink";
import { LinkText, MessageWrapper, StyledText, StyledWrapper } from "./styled-components";

/**
 * Message telling buyers/sellers that their tickets include Fan Protect
 * @param {object} props - props
 * @param props.isMobile - flag determing if mobile or tablet experience
 * @returns JSX Element
 */
export const FanProtectMessage = ({ isMobile = false }) => {
  const message = useContent("cid$#1812463#");
  const learnMoreMessage = useContent("cid$#3026870#");
  const { pageLayoutEnabled } = useContentLayoutContext();

  const ref = useScrollPastTracking(PE_KEYS.FAN_PROTECT_SCROLL_PAST, "home-fan-protect-message", true, 0);

  return (
    <StyledWrapper $removePaddingUsedAsMargin={pageLayoutEnabled} isMobile={isMobile} ref={ref}>
      <FanProtectImageWithLink isMobile={isMobile} />

      <MessageWrapper isMobile={isMobile}>
        <StyledText>{message}</StyledText>
        <FanProtectLink>
          <LinkText>{learnMoreMessage}</LinkText>
        </FanProtectLink>
      </MessageWrapper>
    </StyledWrapper>
  );
};
